import { apolloClient } from '@/common/service/apolloClient'
import httpClient from '@/common/httpClient'

import {
  estimateProductSearchQuery,
  productSearchQuery,
  getCategoriesByBrandQuery,
  subCategoriesQuery
} from '@/search/queries'
import {
  searchProducts as GetSearchProducts,
  brandCategories as BrandCategories
} from '@/search/types'
import { executeQuery } from '@/common/service'

const PRICE_RANGE_ENDPOINT = '/max_quantity_price'

export const estimateSearchProducts = ({
  categoryId, minUnitPrice, maxUnitPrice, printingMethods, facets
  , offset, limit, sortOrder, industryIds, keyword, userDesignVersionUuid, editPatterns }: {
  categoryId: string
  minUnitPrice: number
  maxUnitPrice: number
  printingMethods: string
  facets: []
  offset: number
  limit: number
  sortOrder: string
  industryIds: number[]
  keyword?: string
  userDesignVersionUuid: string
  editPatterns: string[]
}) => {
  return apolloClient.query<GetSearchProducts>({
    query: estimateProductSearchQuery,
    variables: {
      categoryId: categoryId,
      minUnitPrice: minUnitPrice,
      maxUnitPrice: maxUnitPrice,
      printingMethods: printingMethods,
      facets: facets,
      offset: offset,
      limit: limit,
      sortOrder: sortOrder,
      industryIds: industryIds,
      keyword: keyword,
      userDesignVersionUuid,
      editPatterns
    },
    fetchPolicy: 'no-cache'
  })
}

export const getAllSearchProducts = (
  categoryId: string,
  industryIds: number[],
  minUnitPrice: number,
  maxUnitPrice: number,
  printingMethods: string,
  facets: [],
  offset: number,
  limit: number,
  sortOrder: string,
  keyword: string,
  userDesignVersionUuid: string,
  editPatterns: string[]
) => {
  return apolloClient.query<GetSearchProducts>({
    query: productSearchQuery,
    variables: {
      categoryId: categoryId,
      industryIds: industryIds,
      minUnitPrice: minUnitPrice,
      maxUnitPrice: maxUnitPrice,
      printingMethods: printingMethods,
      facets: facets,
      offset: offset,
      limit: limit,
      sortOrder: sortOrder,
      keyword: keyword,
      userDesignVersionUuid,
      editPatterns
    },
    fetchPolicy: 'no-cache'
  })
}

export const getPriceRange = () => {
  return httpClient.get(PRICE_RANGE_ENDPOINT).then(res => {
    return Promise.resolve(res.data)
  }).catch(() => {
    return Promise.resolve({})
  })
}

export const getBrandCategories = (brandId: number) => {
  return apolloClient.query<BrandCategories>({
    query: getCategoriesByBrandQuery,
    variables: { brandId }
  }).then(res => {
    const error = res.errors || res.error
    if (error) {
      return Promise.reject(error)
    }
    return Promise.resolve(res.data.categoriesByBrand)
  })
}

export const getSubCategoryByName = (categoryName: string) => {
  return executeQuery(subCategoriesQuery, { name: categoryName })
}
